import { apiClient } from '@/shared/api';
import type { OrganisationAlias } from '../types';

const BASE_PATH = '/v1/admin/organisations';

export async function getOrganisationAliases(orgId: string): Promise<OrganisationAlias[]> {
  const response = await apiClient.get<{ data?: { aliases: OrganisationAlias[] }; aliases?: OrganisationAlias[] }>(`${BASE_PATH}/${orgId}/aliases`);
  return response.data.data?.aliases || response.data.aliases || [];
}

export async function addOrganisationAlias(
  orgId: string,
  data: Partial<OrganisationAlias>
): Promise<OrganisationAlias> {
  const response = await apiClient.post<{ data?: OrganisationAlias } | OrganisationAlias>(
    `${BASE_PATH}/${orgId}/aliases`,
    { aliases: [data] }
  );
  const body = response.data as { data?: OrganisationAlias } & OrganisationAlias;
  return body.data || body;
}

export async function removeOrganisationAlias(orgId: string, aliasId: string): Promise<void> {
  await apiClient.delete(`${BASE_PATH}/${orgId}/aliases/${aliasId}`);
}
